import React from 'react';
import { Body, Col, FlexRow, Box } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { CarrierLogo, SegmentDetails } from './ItineraryDetailsUtils';
import { PriceFreezeDate } from '@/components/PriceFreezeDateTime/PriceFreezeDateTime';

const capitalize = (string = '') =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

function SegmentHeader({ text, departureDate }) {
  return (
    <FlexRow
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      mb="2x_small"
      aria-label="segmentHeader"
    >
      <Col>
        <Body inline as="span" type="small" color="neutral.70" weight="medium">
          {text && capitalize(text)}
        </Body>
      </Col>
      <Col flex="0 0 auto">
        <Box pr="2x_small" as="span" sx={{ verticalAlign: 'middle' }}>
          <Body inline as="span" type="small" color="neutral.70">
            <PriceFreezeDate format={'EEEddMM'} date={departureDate} />
          </Body>
        </Box>
      </Col>
    </FlexRow>
  );
}

export function Segment({ segment, type }) {
  const { t } = useTranslation();
  const segmentType =
    type === 'outbound'
      ? t('itinerarydetails.departure')
      : t('itinerarydetails.return');

  const departureDate = segment.sections[0].departureDate;
  return (
    <>
      <SegmentHeader
        carrier={segment.carrier}
        text={segmentType}
        departureDate={departureDate}
      />
      <SegmentDetails segment={segment} />

      <Box mt="2x_small" sx={{ verticalAlign: 'middle' }}>
        <Box
          pr="2x_small"
          mt="2x_small"
          as="span"
          sx={{ verticalAlign: 'middle' }}
        >
          <CarrierLogo
            carrierId={segment.carrier.id}
            carrierName={segment.carrier.name}
          />
        </Box>
        <Body inline as="span" type="small" color="neutral.70" weight="medium">
          {segment.carrier.name}
        </Body>
      </Box>
    </>
  );
}
